'use strict'
const Base = require('../base.edit')
const modal = new (require('../../helpers/modal'))
const forms = new (require('../../helpers/forms'))
const ajax = require('../../helpers/ajax')
const sortnodes = require('../../helpers/sortnodes')
const moment = require('moment')

module.exports = class pureHtmlWidget extends Base {

	onInit() {

		let input = document.createElement('input')
		input.type = 'file'
		input.onchange = () => {
			this.popup(input.files[0])
			input.value = ''
		}

		let label = document.createElement('label')
		label.innerHTML = '<i class="material-icons">add</i>'
		label.appendChild(input)
		this._elemButtons.appendChild(label)

		this.config = {
			width: this._config.width,
			height: this._config.height,
			padding: 200,
		}

		this.setActions()
		this.setDrag()

	}

	onDestroy() {
		if (typeof this.removeListener === 'function') {
			this.removeListener()
		}
		const files = this._widget.querySelectorAll('.files li')
		files.forEach(el => {
			el.onclick = null
		})
	}

	onSave() {
		this.cancelSort()
	}

	setActions() {
		const wrapper = this._widget.querySelector('.files')
		const files = this._widget.querySelectorAll('.files li')
		files.forEach(el => {
			el.onclick = e => {
				e.preventDefault()
				this.removeAllActive()
				wrapper.classList.add('edit-tools-sorting')
				el.classList.add('edit-tools-sorting-active')
				this.itemButtons(el)
			}
		})
	}

	setDrag() {
		const wrapper = this._widget.querySelector('.files')
		wrapper.classList.add('edit-tools-drag')
		this.removeListener = sortnodes(wrapper, '.files li',
			() => this.cancelSort(),
			(el, from, to) => {
				const arr = this._data.files
				arr.splice(to, 0, arr.splice(from, 1)[0])
				this.setActions()
			}
		)
	}

	removeAllActive() {
		const files = this._widget.querySelectorAll('.files li')
		files.forEach(el => {
			el.classList.remove('edit-tools-sorting-active')
		})
	}

	itemButtons(el) {

		let i = 0
		let child = el
		while ((child = child.previousElementSibling) != null) {
			i++
		}

		// const i = Array.from(el.parentNode).indexOf(el)

		this.clearTemp()

		let space = document.createElement('span')
		space.className = 'btn-space'

		let moveup = document.createElement('button')
		moveup.innerHTML = '<i class="material-icons">keyboard_arrow_left</i>'
		moveup.onclick = () => this.move(el, i, -1)
		moveup.disabled = i === 0

		let movedown = document.createElement('button')
		movedown.innerHTML = '<i class="material-icons">keyboard_arrow_right</i>'
		movedown.onclick = () => this.move(el, i, 1)
		movedown.disabled = i === this._data.files.length - 1

		let remove = document.createElement('button')
		remove.innerHTML = '<i class="material-icons">delete_forever</i>'
		remove.onclick = () => this.remove(el, i)

		let cancel = document.createElement('button')
		cancel.innerHTML = '<i class="material-icons">playlist_add_check</i>'
		cancel.onclick = () => this.cancelSort()


		this.temp = []
		this.temp.push(space)
		this.temp.push(cancel)
		this.temp.push(moveup)
		this.temp.push(movedown)
		this.temp.push(remove)
		this.temp.forEach(el => {
			this._elemButtons.appendChild(el)
		})


	}

	cancelSort() {
		this.clearTemp()
		this.removeAllActive()
		this._widget.querySelector('.files')
			.classList.remove('edit-tools-sorting')
	}

	clearTemp() {
		if (!this.temp) { return }
		this.temp.forEach(el => {
			el.remove()
		})
	}

	remove(el, i) {
		this._data.files.splice(i, 1)
		el.remove()
		this.clearTemp()
	}

	move(el, i, direction) {
		const g = this._data.files
		let item = g.splice(i, 1)[0]
		let j = i + direction
		if (direction > 0) {
			el.parentElement.insertBefore(el.nextElementSibling, el)
			g.splice(j, 0, item)
		}
		if (direction < 0) {
			el.parentElement.insertBefore(el, el.previousElementSibling)
			g.splice(j, 0, item)
		}
		this.itemButtons(el)
	}

	popup(file) {

		let title = 'Názov súboru'
		let block = document.createElement('div')
		block.className = 'form-block'
		let wrapper = document.createElement('div')
		wrapper.className = 'form-wrapper'
		let div = document.createElement('div')
		div.className = 'form-group'

		let text = document.createElement('input')
		text.value = file.name
		div.appendChild(forms.input('Názov', text))
		wrapper.appendChild(div)
		block.appendChild(wrapper)

		let button = document.createElement('button')
		button.className = 'btn btn-primary'
		button.innerHTML = 'Pridať súbor'
		button.onclick = () => {
			ajax({
				url: '/api/upload/',
				method: 'PUT',
				data: file,
			}).then(resp => {
				this._data.files.push({
					fileName: text.value,
					contentType: file.type,
					fileId: resp.id,
				})
				this._render()
			})
			modal.hide()
		}
		block.appendChild(forms.actions(button))

		modal.show(title, block).then(() => { text.focus() })
	}

}



//////////////////
// WEBPACK FOOTER
// ./src/widgets/file-list-without-date/file-list-without-date.edit.js
// module id = 451
// module chunks = 0